import ky from 'ky'
import { ElMessage } from 'element-plus'
import router from '@/router'
import store from '@/store'

export const HTTP_ERRORS = {
  NETWORK_ERROR: 'network error',
  STATUS_4XX: 'status 4xx',
  STATUS_5XX: 'status 5xx'
}

export class HTTPError extends Error {
  constructor (message, originalError = null) {
    super(message)
    this.name = 'HTTPError'

    if (originalError) {
      this.originalError = originalError
    }
  }
}

/**
 * @param {string} url
 * @param {string} [method=get]
 * @param {object} [data]
 * @param {object} [headers={}]
 * @param {boolean} [convertJson=true]
 * @param {int} [timeout=timeout]
 * @returns {Promise<unknown>}
 */
export default ({ url, method = 'get', data, headers = {}, convertJson = true, timeout = 60000 }) => ky(url, {
  method,
  json: data,
  headers,
  timeout
})
  .then(response => convertJson ? response.json() : response)
  .catch(err => {
    if (!err.response) {
      ElMessage.warning('network error')

      throw new HTTPError(HTTP_ERRORS.NETWORK_ERROR, err)
    } else if ([401, 440].includes(err.response.status) && router.currentRoute.name !== 'login') {
      store.commit('auth/RESET')
      ElMessage.warning('please log in')
      router.push({ name: 'login' })

      throw new HTTPError(HTTP_ERRORS.STATUS_4XX, err)
    } else if (err.response.status === 403) {
      ElMessage.warning('you don\'t have required permissions')
      router.push('/')

      throw new HTTPError(HTTP_ERRORS.STATUS_4XX, err)
    } else if (err.response.status === 400 || (err.response.status >= 500 && err.response.status <= 599)) {
      ElMessage({
        type: 'warning',
        message: `An error occurred. Please try
        <a href="#" onclick="window.location.reload(true)">refreshing the page</a>.
        If the problem persists, please contact support`,
        dangerouslyUseHTMLString: true
      })

      throw new HTTPError(HTTP_ERRORS.STATUS_5XX, err)
    }

    throw err
  })
